// Bell-tent bed layouts (SPA mirror of src/lib/bed-layout.ts). An accommodation
// unit that "sleeps N" can be arranged as combinations of doubles (sleep 2) +
// singles (sleep 1) seating exactly N. The buyer picks one.
export type BedLayout = { doubles: number; singles: number; label: string };

export function bedLayoutLabel(doubles: number, singles: number): string {
  const parts: string[] = [];
  if (doubles > 0) parts.push(`${doubles} double${doubles > 1 ? "s" : ""}`);
  if (singles > 0) parts.push(`${singles} single${singles > 1 ? "s" : ""}`);
  return parts.join(" + ") || ",";
}

export function bedLayoutsForSleeps(sleeps: number | null | undefined): BedLayout[] {
  if (!sleeps || !Number.isFinite(sleeps) || sleeps <= 0) return [];
  const n = Math.floor(sleeps);
  const out: BedLayout[] = [];
  for (let doubles = Math.floor(n / 2); doubles >= 0; doubles--) {
    const singles = n - doubles * 2;
    out.push({ doubles, singles, label: bedLayoutLabel(doubles, singles) });
  }
  return out;
}
